<script setup>
import { Modal } from "bootstrap";
import { useGarantiaStore } from "../../../../store/garantiaStore";
import GarantiaDevolucionItem from "./GarantiaDevolucionItem.vue";

const garantiaStore = useGarantiaStore();


function closeModal() {
  const el = document.getElementById("pedido-devolucion-modal");
  if (!el) return;
  const modal = Modal.getInstance(el) ?? new Modal(el);
  modal.hide();
}
</script>

<template>
  <div
    class="modal fade border-2"
    id="pedido-devolucion-modal"
    tabindex="-1"
    aria-hidden="true"

  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content m-0 border-0" style="border-radius: 12px">
        <div class="modal-header">
          <h5 class="modal-title">Pedir devolución</h5>
        </div>
        <div class="modal-body p-2">
            <h5 class="text-sm">
              Garantias habilitadas para devolucion 
            </h5>
            <small class="text-danger">Recordá que por los lotes con ofertas
              ganadoras se les retiene un 10% del total
            </small>
              <table class="table table-responsive p-3">
                <thead class="text-center m-0 text-xs">
                  <th class="p-1">Garantia</th>
                  <th class="p-1">Entidad</th>
                  <th class="p-1">Medio de Pago</th>
                  <th class="p-1">Total</th>
                  <th class="p-1">Disponible</th>
                  <th class="p-1">Tipo</th>
                  <th class="p-1">A devolver</th>
                  <th class="p-1"></th>
                </thead>
                <tbody>
                  <div class="text-center w-100" v-if="garantiaStore?.comprobantes_aptos_devolucion.length === 0 ">
                    No existen garantias a Devolver
                  </div>
                  <template v-else   v-for="(garantia , index) in garantiaStore?.comprobantes_aptos_devolucion" v-bind:key="index">
                    <GarantiaDevolucionItem  :garantia_index="index">

                    </GarantiaDevolucionItem>    
                  </template>
                </tbody>
              </table>
        </div>

        <div class="modal-footer">
          <button class="btn btn-outline-secondary" @click="closeModal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
